import { useRef, useState } from 'react';

import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import { useArrowsClickHook } from '../useArrowsClickHook/useArrowsClickHook';
import { useNextButtonsDuringResize } from '../useNextButtonsDuringResize/useNextButtonsDuringResize';
import { useNextButtonsDuringTotalWidth } from '../useNextButtonsDuringTotalWidth/useNextButtonsDuringTotalWidth';

function useNextButtonsCombiner(width: number) {
  const {
    setNextButtons,
    refElementInner,
    totalWidth,
    offset,
    hasAssetsMarkedByNumber,
    setRailCardsListRefScrollTo,
    railCardsListRef,
  } = useRailContext();
  const {
    data: { items },
    imageHeight, // should be removed after fallback params becomes required
    imageWidth, // should be removed after fallback params becomes required
  } = useWidgetContext();
  const [state, setState] = useState({
    isLeftNextButton: offset?.current! > 0,
    isRightNextButton:
      offset?.current! + (refElementInner?.current?.clientWidth || document.body.clientWidth) < totalWidth,
  });
  const scrolling = useRef(false);
  const prevWidth = useRef(width);

  useNextButtonsDuringResize({ width, offset, scrolling, prevWidth, totalWidth, refElementInner, setState });

  useNextButtonsDuringTotalWidth({ scrolling, offset, totalWidth, refElementInner, setState });

  const scrollHandle = (newOffset: number, blockWidtht: number) => {
    scrolling.current = true;
    const buttonsView = {
      isLeftNextButton: newOffset > 0,
      isRightNextButton: newOffset + blockWidtht < totalWidth,
    };
    // set value for RailContext
    setNextButtons({ ...buttonsView });
    // set value for local state
    setState({ ...buttonsView });
    scrolling.current = false;
  };

  const clickHandle = useArrowsClickHook({
    scrollHandle,
    setRailCardsListRefScrollTo,
    items,
    totalWidth,
    offset,
    railCardsListRef,
    refElementInner,
    imageWidth,
    imageHeight,
    hasAssetsMarkedByNumber,
  });
  const { isLeftNextButton, isRightNextButton } = state;

  return { isLeftNextButton, isRightNextButton, clickHandle, imageHeight };
}

export { useNextButtonsCombiner };
